import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ValidateCodeModalPage } from './validate-code-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ValidateCodeModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ValidateCodeModalPageRoutingModule {}
